import { useMemo } from 'react';

import { Bean, ValidationRules } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { visitSettlementTranslationKeys } from '../../../translations';
import { VisitSettlementFormController } from '../VisitSettlementForm';

const t = visitSettlementTranslationKeys.shared.form.payment.methodDescriptionInput;

type PaymentMethodDescriptionInputProps = Pick<VisitSettlementFormController, 'register'>;

export const PaymentMethodDescriptionInput = (props: PaymentMethodDescriptionInputProps): JSX.Element => {
   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         maxLength: 50,
      };
   }, []);

   return (
      <TextInput
         testId={'paymentMethodDescription'}
         controller={props.register('payment.methodDescription', validationRules)}
         placeholder={t.placeholder}
         defaultValue={null}
      />
   );
};
